<main class="ot-sign-in-layout" [ngClass]="{'ot-auth-error': isAuthenticationError}">

  <div class="ot-wordmark-wrapper" [ngClass]="{'ot-collapsed-margin': config?.welcomeMessage}">
    <img class="ot-wordmark-phone" alt="OpenText File360" src="assets/images/sign_in_phone_file360.svg">
    <img class="ot-wordmark-tablet" alt="OpenText File360" src="assets/images/sign_in_tablet_file360.svg">
    <img class="ot-wordmark-desktop" alt="OpenText File360" src="assets/images/sign_in_file360.svg">
  </div>


  <!-- System message, no error-->
  <div class="ot-system-message" *ngIf="!isAuthenticationError && config?.welcomeMessage"
    [innerHtml]="config?.welcomeMessage"></div>

  <!-- Error message-->
  <div class="ot-error-message-container" *ngIf="isAuthenticationError">
    <div class="ot-error-message">
      {{authenticationErrorMessage}}
    </div>
  </div>

  <form (ngSubmit)="onSubmit()" #logOnForm="ngForm">
    <div class="ot-user-wrapper">
      <input #inputUser class="ot-sign-in" type="text" placeholder="User name" required [(ngModel)]="model.Name"
        [disabled]="config?.systemOffline || isLoggingOn" name="username" autocomplete="username" autofocus>
      <img src="assets/images/li_form_validation_error18.svg" class='ot-sign-in-error-icon'>
    </div>

    <div class="ot-password-wrapper">
      <input #inputPassword class="ot-sign-in" type="password" placeholder="Password" required
        [disabled]="config?.systemOffline || isLoggingOn" [(ngModel)]="password" name="current-password"
        autocomplete="current-password">
      <img src="assets/images/li_form_validation_error18.svg" class='ot-sign-in-error-icon'>
    </div>

    <div class="ot-sign-in-wrapper">
      <button class="ot-sign-in" type="submit"
        [disabled]="logOnForm.invalid || isLoggingOn || config?.systemOffline">Sign
        in</button>
    </div>
  </form>

  <button class="ot-forgot-password" *ngIf="(config !== undefined ? config!.forgotPasswordMessage.length : 0) > 0"
    (click)="forgotPassword()">Forgot
    password?</button>
  <div class="ot-forgot-password-message-wrapper">
    <div class="ot-forgot-password-text" *ngIf="showForgotPassword" [innerHtml]="config?.forgotPasswordMessage"></div>
  </div>

  <div class='ot-flex'></div>

  <div class="ot-copyright-wrapper">
    <p class="ot-copyright">
      Copyright &copy; {{year}} Open&nbsp;Text. All Rights Reserved.
      <span>Trademarks owned by Open&nbsp;Text.</span>
    </p>
  </div>

</main>